// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-MessageLogs-module__messageColumn-dSCgN {
  width: 100%;
}

.nightbot-MessageLogs-module__createdAtColumn-MHI4H {
  white-space: nowrap;
}

.nightbot-MessageLogs-module__userColumn-Ub6ih {
  white-space: nowrap;
}

.nightbot-MessageLogs-module__userColumn-Ub6ih .nightbot-MessageLogs-module__userStack-MUCKv {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

.nightbot-MessageLogs-module__userColumn-Ub6ih .nightbot-MessageLogs-module__userStack-MUCKv .nightbot-MessageLogs-module__userTimestamp-aQL2R {
      color: var(--text-secondary);
    }

.nightbot-MessageLogs-module__userColumn-Ub6ih .nightbot-MessageLogs-module__userStack-MUCKv .nightbot-MessageLogs-module__userMessage-XgJLd {
      width: 100%;
    }
`, "",{"version":3,"sources":["webpack://./src/components/pages/MessageLogs.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AAgBrB;;AAdE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EASV;;AAPE;MACE,4BAA4B;IAC9B;;AAEA;MACE,WAAW;IACb","sourcesContent":[".messageColumn {\n  width: 100%;\n}\n\n.createdAtColumn {\n  white-space: nowrap;\n}\n\n.userColumn {\n  white-space: nowrap;\n\n  .userStack {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .userTimestamp {\n      color: var(--text-secondary);\n    }\n\n    .userMessage {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageColumn": `nightbot-MessageLogs-module__messageColumn-dSCgN`,
	"createdAtColumn": `nightbot-MessageLogs-module__createdAtColumn-MHI4H`,
	"userColumn": `nightbot-MessageLogs-module__userColumn-Ub6ih`,
	"userStack": `nightbot-MessageLogs-module__userStack-MUCKv`,
	"userTimestamp": `nightbot-MessageLogs-module__userTimestamp-aQL2R`,
	"userMessage": `nightbot-MessageLogs-module__userMessage-XgJLd`
};
export default ___CSS_LOADER_EXPORT___;
